import React from 'react';
import { DeepMap, FieldError, UseFormMethods, Validate } from 'react-hook-form';
import {
  passwordDigitsCount,
  passwordLowercaseCharactersCount,
  passwordMinLength,
  passwordSymbolsCount,
  passwordUppercaseCharactersCount
} from '../../common/passwordValidator';

export interface IOwnProps {
  label: string;
  name: string;
  type?: 'text' | 'email' | 'password';
  validate?: Validate | Record<string, Validate>;
  required?: boolean;
  formHook: UseFormMethods<Record<string, any>>;
}

const passwordPrefix = 'Password should contain';

const errorMessages: { [key: string]: string } = {
  default: 'This value is invalid',
  required: 'Required',
  email: 'Email has invalid format',
  emailIsAlreadyUsed: 'This email is already registered',
  ethereumAddress: 'Ethereum address has invalid format',
  ethereumAddressIsAlreadyUsed: 'This Ethereum address is already registered',
  password_min: `${passwordPrefix} at lest ${passwordMinLength} characters`,
  password_uppercase: `${passwordPrefix} at lest ${passwordUppercaseCharactersCount} uppercase characters`,
  password_lowercase: `${passwordPrefix} at lest ${passwordLowercaseCharactersCount} lowercase characters`,
  password_digits: `${passwordPrefix} at lest ${passwordDigitsCount} digits`,
  password_symbols: `${passwordPrefix} at lest ${passwordSymbolsCount} symbols`,
  apiKyeIsAlreadyUsed: 'This API key name is already add to your list'
};

export default function FormInput({ label, type, name, required, validate, formHook }: IOwnProps) {
  const { register, errors } = formHook;

  return <div className="form-group position-relative">
    <label>{label} {required && <span className="text-danger"> *</span>}</label>
    <input
      name={name}
      type={type || 'text'}
      className="form-control"
      placeholder={`Enter ${label}`}
      ref={register({ required, maxLength: 100, validate })}
    />
    <div className="text-danger mt-1">
      <small>
        {
          processErrors(name, errors)
        }
      </small>
    </div>
  </div>
}

function processErrors(name: string, errors: DeepMap<Record<string, any>, FieldError>) {
  const message = errors[name]?.message;
  const type = errors[name]?.type;

  if (message) {
    return errorMessages[message];
  }

  if (type) {
    return errorMessages[type] || errorMessages.default;
  }
}